// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3PQZX","title":"Header_title__TJuKD","left":"Header_left__3YBm5","clinicName":"Header_clinicName__uHK3o"};